import { MonnifySDK } from './monnify'
export default MonnifySDK


// WEBPACK FOOTER //
// ./src/modules/MonnifySDK/index.js